import { useTranslation } from 'react-i18next'

import { WarningIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text, Tooltip } from '@reveni-io/reveni-ui'

import { pendingAlertsLabelKeys } from '../constants'
import { getCountLabelKey } from '../helpers'
import * as Styles from './styles'

const ParcelCardPendingAlerts = ({ pendingAlertsCount }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const pendingAlertsLabel = t(getCountLabelKey(pendingAlertsCount, pendingAlertsLabelKeys), {
    count: pendingAlertsCount,
  })

  return (
    <Tooltip
      backgroundColor={theme.colors.text.default}
      title={
        <Text type="bodySRegular" color={theme.colors.text.inverse}>
          {pendingAlertsLabel}
        </Text>
      }
    >
      <Styles.IconContainer role="img" aria-label={pendingAlertsLabel}>
        <WarningIcon size={16} color={theme.colors.warning.default} />
      </Styles.IconContainer>
    </Tooltip>
  )
}

export default ParcelCardPendingAlerts
